/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Sales
 * Это Sales api сервер, для запросов от Frontend.  Для запросов требуется указать header с Authorization и типом Bearer.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface RequestSaleCreateOneItem
 */
export interface RequestSaleCreateOneItem {
  /**
   *
   * @type {string}
   * @memberof RequestSaleCreateOneItem
   */
  id: string
  /**
   *
   * @type {string}
   * @memberof RequestSaleCreateOneItem
   */
  countOfSell: string
}

/**
 * Check if a given object implements the RequestSaleCreateOneItem interface.
 */
export function instanceOfRequestSaleCreateOneItem(
  value: object,
): value is RequestSaleCreateOneItem {
  if (!('id' in value) || value['id'] === undefined) return false
  if (!('countOfSell' in value) || value['countOfSell'] === undefined)
    return false
  return true
}

export function RequestSaleCreateOneItemFromJSON(
  json: any,
): RequestSaleCreateOneItem {
  return RequestSaleCreateOneItemFromJSONTyped(json, false)
}

export function RequestSaleCreateOneItemFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): RequestSaleCreateOneItem {
  if (json == null) {
    return json
  }
  return {
    id: json['id'],
    countOfSell: json['countOfSell'],
  }
}

export function RequestSaleCreateOneItemToJSON(
  json: any,
): RequestSaleCreateOneItem {
  return RequestSaleCreateOneItemToJSONTyped(json, false)
}

export function RequestSaleCreateOneItemToJSONTyped(
  value?: RequestSaleCreateOneItem | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value
  }

  return {
    id: value['id'],
    countOfSell: value['countOfSell'],
  }
}
